import React, { useEffect, useState } from 'react'
import { HTTP } from '../../../../api/resources'
import NoListEditor from '../../Utilities/NoListEditor'

export default function PageSummary({user, page, summary, close, proceed}) {
    const [description, setDescription] = useState(summary ? summary.summary : '')

    const handleUpdate = async () => {
        try {
            let response = await updateRequest()
            proceed(response.data)
            close()
            Alert.show('notice', 'Custom description updated successfully')
        } catch {
            Alert.show('error', 'Error saving description, try again')
        }
    }

    const updateRequest = () => {
        return HTTP.post(`/page/summary/${page.id}`, {id: summary ? summary.id : null, user_id: user.id, value: description})
    }
  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center">
                <h4>Custom Page Descriptions</h4>

                <div className="form-group">
                    <label htmlFor="body">Description</label>
                    <NoListEditor
                        value={description}
                        returnChange={(value) => setDescription(value)}
                    />
                    <div className="mt-1">
                        This description will replace the page description in the users profile of this page, it can be used to give extra instructions, 
                        give more details etc
                    </div>
                </div>

                <div className="pt-3">
                    <button onClick={() => handleUpdate()} type="button" className="btn btn-primary mr-2" disabled={!description}>
                        Update
                    </button>

                    <button onClick={close} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
